export const FETCH_ACCOUNT_REQUEST = 'FETCH_ACCOUNT_REQUEST'
export const FETCH_ACCOUNT_SUCCESS = 'FETCH_ACCOUNT_SUCCESS'
export const FETCH_ACCOUNT_FAIL = 'FETCH_ACCOUNT_FAIL'
